// extracted by mini-css-extract-plugin
export var autoExpand = "_48-8";
export var container = "_48-7";
export var containerWidth = "_48-5";
export var disabled = "_48-2";
export var error = "_48-3";
export var fullWidth = "_48-6";
export var inputWrapper = "_48-0";
export var small = "_48-1";
export var textarea = "_48-4";